function _isPlaceholder(a) {
       return a != null && typeof a === 'object' && a['@@functional/placeholder'] === true;
}
module.exports = _isPlaceholder;


//////////////////
// WEBPACK FOOTER
// ./node_modules/ramda/src/internal/_isPlaceholder.js
// module id = 147
// module chunks = 0